export default "__VITE_ASSET__CWyNH3pZ__"